/**
 * Tehran business clock — the ONE wall-clock leaf, shared by BOTH server and web. Iran runs at a fixed
 * **UTC+03:30** year-round (DST abolished 2022); the runtime clock is UTC, so `new Date().toISOString()`
 * yields the UTC calendar day — which every evening from ~20:30 Tehran to midnight is still YESTERDAY in
 * Tehran. Any "today" / "this month" a screen or the finance engine derives MUST come from these helpers,
 * never a raw `toISOString()` (audit DT-H2). The server's `domain/clock` mirrors this; the web must use it too
 * for date DEFAULTS (month pickers, quick-ranges) so it can't open on the wrong month in the Tehran evening.
 */
const TEHRAN_OFFSET_MS = 3.5 * 60 * 60 * 1000; // +03:30, no DST
/** Full ISO timestamp shifted to Tehran wall-clock (date/time parts read as Tehran local). */
export function tehranNowIso() {
    return new Date(Date.now() + TEHRAN_OFFSET_MS).toISOString();
}
/** Tehran calendar date, `YYYY-MM-DD`. */
export function tehranToday() {
    return tehranNowIso().slice(0, 10);
}
/** Tehran calendar month, `YYYY-MM`. */
export function tehranYm() {
    return tehranNowIso().slice(0, 7);
}
//# sourceMappingURL=clock.js.map